import { isNumber } from './utils'

export const getMaxObjectKey = (obj) =>
  Object.keys(obj).reduce((a, b) => (obj[a] > obj[b] ? a : b));

export const isObjectHasEqualValues = (obj) =>
  Object.values(obj).every((value, index, arr) =>
    index > 0 ? value === arr[index - 1] : true
  );
export const getObjectsDifference = (obj1, obj2) => [
  ...Object.keys(obj1), ...Object.keys(obj2)
].reduce((acc, key) => {
  if (obj1[key] !== obj2[key]) {
    acc[key] = obj1[key] == null ? obj2[key] : obj1[key]
  }
  return acc
}, {})
export const combineObjects = (
  objects,
  { average = false, round = false } = {}
) => {
  const combined = objects.reduce((acc, obj) => {
    if (!obj || typeof obj !== 'object') {
      return acc;
    }
    Object.entries(obj).forEach(([key, value]) => {
      if (isNumber(value)) {
        if (!acc[key]) {
          acc[key] = 0;
        }
        acc[key] += +value;
      }
    });
    return acc;
  }, {});

  return average
    ? Object.fromEntries(
      Object.entries(combined).map(([key, score]) => {
        let value = score / objects.length;
        if (round) {
          value = Number(value.toFixed(2));
        }
        return [key, value];
      })
    )
    : combined;
};

export const isObjectHasAnyValue = (obj) => Object.values(obj).every(Boolean);

export const sortObjectByValues = (obj, keys = []) => {
  let sorted = Object.entries(obj).sort((a, b) => b[1] - a[1]);
  if (keys.length) {
    sorted = sorted.sort((a, b) => {
      if (a[1] !== b[1]) {
        return 0;
      }
      return keys.indexOf(a[0]) - keys.indexOf(b[0]);
    });
  }
  return Object.fromEntries(sorted);
};

export const objectValuesToPercent = (obj, defaultTotal = 0) => {
  const total = defaultTotal || Object.values(obj).reduce((acc, v) => acc + v);
  return Object.fromEntries(
    Object.entries(obj).map(([key, value]) => [
      key,
      Math.floor((value / (total || 1)) * 100),
    ])
  );
};

export const valuesToPercentage = (result, { max, round }) =>
  Object.fromEntries(
    Object.entries(result).map(([key, value]) => {
      const maxValue = (() => {
        if (max == null) {
          return 1;
        }
        if (typeof max === 'function') {
          return max(key, value);
        }
        return typeof max === 'number' ? max : max[key] || 1;
      })();
      let resultValue = (value / maxValue) * 100;
      if (round) {
        resultValue = Number(resultValue.toFixed(2));
      }
      return [key, resultValue];
    })
  );